import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('h1',{staticClass:"seo-only"},[_vm._v("佑昇生殖中心掛號方式與行動 App")]),_c(VImg,{staticClass:"rounded",attrs:{"src":"/reserve01.png","alt":"佑昇生殖中心掛號方式與行動 App 操作說明","eager":"","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }